import * as actionType from "../constants";
import * as commonData from "../Common";
import action from ".";
export const bulkUpdate = (inputs) => async (dispatch) => {
  dispatch({
    type: actionType.BULK_UPDATE_PROCESS,
  });
  const url = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${url}tattle/bulk-update`, {
      method: "post",
      body: JSON.stringify(inputs),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      dispatch({
        type: actionType.BULK_UPDATE_DONE,
        payload: {
          code: rdata.code,
          message: rdata.message,
          title: rdata.status,
          board: true,
        },
      });
      return rdata;
    }
  } catch (error) {
    console.log(error.message);
  }
};
